import { connect } from 'react-redux';
import User from './User';

const mapStateToProps = (state, ownProps) => {
  const user = ownProps.id && state.users[ownProps.id];
  const identityId = state.identity.id;

  return {
    firstName: user ? user.firstName : '',
    lastName: user ? user.lastName : '',
    mentionName: user ? user.mentionName : '',
    status: user ? user.status : '',
    isCurrentUser: identityId === ownProps.id,
  }
};

export default connect(mapStateToProps)(User);
